
export default {
    install(Vue) {
        Vue.prototype.$isMobile = function () {
            return window.innerWidth < 1000
        }
    }
}
